"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPolicy = void 0;
/**
 * Check a policy result.  Returns true if policy result exists and has no failure reason, false other
 * @param policyResult
 */
function checkPolicy(policyResult) {
    return !!(policyResult && policyResult.failureReason == null);
}
exports.checkPolicy = checkPolicy;
//# sourceMappingURL=PolicyResultHelper.js.map